import { useState, useCallback, type ReactNode } from 'react';
import { LocaleContext, type LocaleCode, type Dir } from './LocaleContext';

export interface LocaleProviderProps {
  children: ReactNode;
  defaultLocale?: LocaleCode;
  defaultDirection?: Dir;
}

export const LocaleProvider = ({
  children,
  defaultLocale = 'en',
  defaultDirection = 'ltr',
}: LocaleProviderProps) => {
  const [locale, setLocale] = useState<LocaleCode>(defaultLocale);
  const [direction, setDirection] = useState<Dir>(defaultDirection);

  const updateLocale = useCallback(async (newLocale: LocaleCode) => {
    setLocale(newLocale);
  }, []);

  const isRtl = direction === 'rtl';

  return (
    <LocaleContext
      value={{
        locale,
        updateLocale,
        direction,
        setDirection,
        isRtl,
      }}
    >
      {children}
    </LocaleContext>
  );
};
